import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import InfoBox from '../../../InfoBox'
import Thumbnail from '../../../Thumbnail'

class NextScheduledMedia extends PureComponent {
    static propTypes = {
        id: PropTypes.number,
        name: PropTypes.string,
        isEmpty: PropTypes.bool,
        loading: PropTypes.number,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        id: null,
        name: '',
        isEmpty: true,
        loading: null,
    }

    renderPlayer = () => {
        const { id } = this.props
        return <Thumbnail mediaId={id} withPlayer />
    }

    render() {
        const { name, isEmpty, loading, t } = this.props
        return <InfoBox isEmpty={isEmpty} loading={loading} title={t('Next Scheduled Media')} value={name} img={this.renderPlayer()} />
    }
}

export default withTranslation()(NextScheduledMedia)
